import { Nullish } from './common.types'
import { BaseTableRequest } from './table.types'

export enum TeamType {
  Individual = 'individual',
  Group = 'group',
}

export const TeamTypeOptions = [
  { label: 'Individual', value: TeamType.Individual },
  { label: 'Group', value: TeamType.Group },
]

export type TeamCreateRequest = {
  name: string
  type: TeamType
}

export interface Team {
  isDefault: boolean
  isActive: boolean
  id: number
  createdBy: number
  ownerId: number
  name: string
  type: TeamType
  accessCodeId: number
  updatedAt: Nullish<string>
  createdAt: string
  updatedBy: Nullish<number>
  deletedAt: Nullish<number>
}

export type TeamUpdateRequest = Partial<Team>

export interface TeamMember {
  id: number
  careTeamId: number
  userId: Nullish<number>
  email: string
  firstName: string
  lastName: string
  phone: string
  accessCodeId: number
  address: string
  role: string[]
  otherRole: string
  about: string
  user: Nullish<UserTeamMember>
}

export interface UserTeamMember extends Omit<TeamMember, 'firstName' | 'lastName' | 'user'> {
  firstname: string
  lastname: string
}

export interface TeamMembersRequest extends BaseTableRequest {
  id: number
}

export interface TeamMemberCreateRequest {
  id: number
  userId: number
  email: string
  firstName: string
  lastName: string
  about: string
  role: string[]
  otherRole?: string
  addressStreet: string
  addressZipCode: string
  addressCountry: string
  addressCity: string
  addressState: string
  phone: string
  comments: string
}

export interface TeamMemberRemoveRequest {
  id: number // Team ID
  memberId: number
}

export enum TraineeTeamRole {
  directCareGiver = 'directCareGiver',
  supervisor = 'supervisor',
  activityDirector = 'activityDirector',
  physicalTherapist = 'physicalTherapist',
  dietaryStaff = 'dietaryStaff',
  custodialStaff = 'custodialStaff',
  leadFamilyCarePartner = 'leadFamilyCarePartner',
  nearestFamilyMember = 'nearestFamilyMember',
  medicalPowerOfAttorney = 'medicalPowerOfAttorney',
  financialPowerOfAttorney = 'financialPowerOfAttorney',
  other = 'other',
}

export const traineeAllRoles = [
  {
    label: 'Direct caregiver',
    value: TraineeTeamRole.directCareGiver,
  },
  {
    label: 'Supervisor',
    value: TraineeTeamRole.supervisor,
  },
  {
    label: 'Activities director',
    value: TraineeTeamRole.activityDirector,
  },
  {
    label: 'Physical therapist',
    value: TraineeTeamRole.physicalTherapist,
  },
  {
    label: 'Dietary staff',
    value: TraineeTeamRole.dietaryStaff,
  },
  {
    label: 'Custodial staff',
    value: TraineeTeamRole.custodialStaff,
  },
  {
    label: 'Lead family care partner',
    value: TraineeTeamRole.leadFamilyCarePartner,
  },
  {
    label: 'Nearest family member',
    value: TraineeTeamRole.nearestFamilyMember,
  },
  {
    label: 'Medical power of attorney',
    value: TraineeTeamRole.medicalPowerOfAttorney,
  },
  {
    label: 'Financial power of attorney',
    value: TraineeTeamRole.financialPowerOfAttorney,
  },
  {
    label: 'None of the above',
    value: TraineeTeamRole.other,
  },
]

export const traineeRoleOptions = traineeAllRoles.filter((role) => {
  const excludedRoles = [
    TraineeTeamRole.leadFamilyCarePartner,
    TraineeTeamRole.nearestFamilyMember,
    TraineeTeamRole.medicalPowerOfAttorney,
    TraineeTeamRole.financialPowerOfAttorney,
  ]
  return !excludedRoles.includes(role.value)
})
